import {GET_REDEMPTION_CODE_CLEAR, GET_REDEMPTION_CODE_REQUEST, UPGRADE_REDEMPTION_CLEAR, UPGRADE_REDEMPTION_REQUEST} from '../constants/reducer.const';

export const upgradeRedemptionAction = (payload)=>({type: UPGRADE_REDEMPTION_REQUEST, payload});
export const upgradeRedemptionClearAction = ()=>({type: UPGRADE_REDEMPTION_CLEAR, payload: {}});

// Get all redemption list
export const getRedemptionCodeAction = (payload)=>({type: GET_REDEMPTION_CODE_REQUEST, payload});
export const getRedemptionCodeClearAction = ()=>({type: GET_REDEMPTION_CODE_CLEAR, payload: {}});
